// Bug severities in display order, plus the tooltip copy shown on severity controls.
export const SEVERITIES = ['critical', 'high', 'medium', 'low']

export const SEVERITY_TOOLTIPS: Record<string, string> = {
  critical: 'Critical — blocks core functionality',
  high: 'High — significant impact on users',
  medium: 'Medium — moderate impact, workaround exists',
  low: 'Low — minor issue, cosmetic or edge case',
}
